import React, { useEffect } from "react";
import { connect } from "react-redux";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import {
  mapStateToProps,
  surveyResultsReducer,
  mapDispatchToProps,
} from "./SurveyResults.store";
import SurveyReader from "../../../library/SurveyReader/SurveyReader";

export const SmartSurveyResults = (props) => {
  const {
    fetchSurveyResults,
    surveyResults,
    surveyData,
    surveyDefinitionId,
    participantId,
    resetState,
  } = props;

  useEffect(() => {
    if (surveyDefinitionId) {
      fetchSurveyResults(surveyDefinitionId, participantId);
    }
  }, [fetchSurveyResults, participantId, surveyDefinitionId]);

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  return <SurveyReader surveyData={surveyData} surveyResults={surveyResults} />;
};

export default dynamic(
  "surveyResultsReducer",
  subspaced({
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(surveyResultsReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartSurveyResults));
